type RequestHeaders = Record<string, string | null | undefined>;

export const authRequestHeaders = (
  headers: RequestHeaders | undefined,
  { anonymous, token }: { anonymous?: boolean; token: string | null }
): RequestHeaders => {
  const nextHeaders = { ...headers };

  if (anonymous) {
    delete nextHeaders.idtoken;
    return nextHeaders;
  }

  nextHeaders.idtoken = token;
  return nextHeaders;
};
